import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import React, { useState } from "react";
import { FormattedMessage, IntlShape, injectIntl } from "react-intl";
import { fileBlobToDataUrl } from "../../../utils/fileUtils";
import CustomDialogSignature from "./ContractSignature";
import { makeStyles, Theme } from "@material-ui/core";
import { CustomButton } from "../../Ui/CustomButton";
import CustomFileUploadSimple from "../../Ui/CustomButtonUploadFile";
import { Pen, Upload } from "lucide-react";

const styles = makeStyles((theme: Theme) => ({
  container: {
    marginTop: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
    "& > button": {
      margin: theme.spacing(1),
    },
  },
  signatureBlock: {
    textAlign: "center",
    margin: theme.spacing(0, 2),
  },
  signatureContainer: {
    border: "1px solid #DFDFDF",
    borderRadius: 7,
    width: 200,
    height: 200,
    maxWidth: 300,
    maxHeight: 300,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: theme.spacing(2, 0),
  },
  signature: {
    maxWidth: "100%",
    maxHeight: "100%",
  },
  icon: {
    marginRight: theme.spacing(1),
  },
}));

interface ContractSignatureControlPropsInterface {
  intl: IntlShape;
  signatureImage: string;
  title: string;
  handleUploadSignature(fileData: string): void;
  handleSaveSignature(signatureData: string): void;
  disabled?: boolean;
}

const ContractSignatureControl = (
  props: ContractSignatureControlPropsInterface,
) => {
  const {
    handleUploadSignature,
    handleSaveSignature,
    intl,
    signatureImage,
    disabled,
    title,
  } = props;

  const classes = styles();
  const [isSignatureDialogOpen, setIsSignatureDialogOpen] = useState(false);

  const handleUploadChange = (file: File) => {
    fileBlobToDataUrl(file).then((data: string) => handleUploadSignature(data));
  };

  const handleOpenSignatureDialog = () => {
    setIsSignatureDialogOpen(true);
  };

  const handleSignatureDialogClose = () => {
    setIsSignatureDialogOpen(false);
  };

  return (
    <Box className={classes.container}>
      <CustomFileUploadSimple
        type="button"
        variant="outline4"
        handleChange={handleUploadChange}
        label="contract.loadImage"
        disabled={disabled}
        fullWidthMobile
        startIcon={<Upload className="w-4 h-4 mr-2" />}
      />

      <FormattedMessage id="contract.or" />

      <CustomButton
        type="button"
        variant="outline4"
        onClick={handleOpenSignatureDialog}
        label="contract.signature"
        disabled={disabled}
        fullWidthMobile
        startIcon={<Pen className="w-4 h-4 mr-2" />}
      />

      <Box className={classes.signatureBlock}>
        <Typography>
          <strong>{title}</strong>
        </Typography>
        <Typography>Signature</Typography>
        <Box className={classes.signatureContainer}>
          {!!signatureImage && (
            <img
              alt="signature"
              src={signatureImage}
              className={classes.signature}
            />
          )}
        </Box>
      </Box>

      <CustomDialogSignature
        open={isSignatureDialogOpen}
        handleClose={handleSignatureDialogClose}
        handleSave={handleSaveSignature}
      />
    </Box>
  );
};

export default injectIntl(ContractSignatureControl);
